/** Get Dashboard Chart data */
export const GET_SERVICES_SUCCESS = "GET_SERVICES_SUCCESS";
export const GET_SERVICES_FAIL = "GET_SERVICES_FAIL";
export const GET_SERVICES = "GET_SERVICES";
export const GET_SPECIFIC_SERVICES_SUCCESS = "GET_SPECIFIC_SERVICES_SUCCESS";
export const GET_SPECIFIC_SERVICES_FAIL = "GET_SPECIFIC_SERVICES_FAIL";
export const GET_SPECIFIC_SERVICES = "GET_SPECIFIC_SERVICES";
export const GET_REDIRECT_SLACK_SUCCESS = "GET_REDIRECT_SLACK_SUCCESS";
export const GET_REDIRECT_SLACK_FAIL = "GET_REDIRECT_SLACK_FAIL";
export const GET_REDIRECT_SLACK = "GET_REDIRECT_SLACK";
export const POST_SERVICE = "POST_SERVICE";
export const POST_SERVICE_SUCCESS = "POST_SERVICE_SUCCESS";
export const POST_SERVICE_FAIL = "POST_SERVICE_FAIL";
export const POST_UPDATE_SERVICE = "POST_UPDATE_SERVICE";
export const POST_UPDATE_SERVICE_SUCCESS = "POST_UPDATE_SERVICE_SUCCESS";
export const POST_UPDATE_SERVICE_FAIL = "POST_UPDATE_SERVICE_FAIL";
export const POST_RESEND_SERVICE_EMAIL_VERIFICATION = "POST_RESEND_SERVICE_EMAIL_VERIFICATION";
export const POST_RESEND_SERVICE_EMAIL_VERIFICATION_SUCCESS = "POST_RESEND_SERVICE_EMAIL_VERIFICATION_SUCCESS";
export const POST_RESEND_SERVICE_EMAIL_VERIFICATION_FAIL = "POST_RESEND_SERVICE_EMAIL_VERIFICATION_FAIL";
export const POST_TEST_NOTIFICATION = "POST_TEST_NOTIFICATION";
export const POST_TEST_NOTIFICATION_SUCCESS = "POST_TEST_NOTIFICATION_SUCCESS";
export const POST_TEST_NOTIFICATION_FAIL = "POST_TEST_NOTIFICATION_FAIL";
export const GET_INTEGRATION_KEYS = "GET_INTEGRATION_KEYS";
export const GET_INTEGRATION_KEYS_SUCCESS = "GET_INTEGRATION_KEYS_SUCCESS";
export const GET_INTEGRATION_KEYS_FAIL = "GET_INTEGRATION_KEYS_FAIL";
export const GET_INTEGRATION_ACTION_URL = "GET_INTEGRATION_ACTION_URL";
export const GET_INTEGRATION_ACTION_URL_SUCCESS = "GET_INTEGRATION_ACTION_URL_SUCCESS";
export const GET_INTEGRATION_ACTION_URL_FAIL = "GET_INTEGRATION_ACTION_URL_FAIL";
export const POST_CREATE_INTEGRATION_KEY = "POST_CREATE_INTEGRATION_KEY";
export const POST_CREATE_INTEGRATION_KEY_SUCCESS = "POST_CREATE_INTEGRATION_KEY_SUCCESS";
export const POST_CREATE_INTEGRATION_KEY_FAIL = "POST_CREATE_INTEGRATION_KEY_FAIL";
export const RESET_INTEGRATION_URL = 'RESET_INTEGRATION_URL';
export const GET_NOTIFICATION_CHANNEL = "GET_NOTIFICATION_CHANNEL";
export const GET_NOTIFICATION_CHANNEL_SUCCESS = "GET_NOTIFICATION_CHANNEL_SUCCESS";
export const GET_NOTIFICATION_CHANNEL_FAIL = "GET_NOTIFICATION_CHANNEL_FAIL";
export const GET_PAGERDUTY_SERVICES = "GET_PAGERDUTY_SERVICES";
export const GET_PAGERDUTY_SERVICES_SUCCESS = "GET_PAGERDUTY_SERVICES_SUCCESS";
export const GET_PAGERDUTY_SERVICES_FAIL = "GET_PAGERDUTY_SERVICES_FAIL";
export const GET_OPSGENIE_SERVICES = "GET_OPSGENIE_SERVICES";
export const GET_OPSGENIE_SERVICES_SUCCESS = "GET_OPSGENIE_SERVICES_SUCCESS";
export const GET_OPSGENIE_SERVICES_FAIL = "GET_OPSGENIE_SERVICES_FAIL";

export const GET_MASTER_BLUEJAY_COMMUNICATION_CHANNEL = 'GET_MASTER_BLUEJAY_COMMUNICATION_CHANNEL'

export const GET_MASTER_BLUEJAY_COMMUNICATION_CHANNEL_SUCCESS = 'GET_MASTER_BLUEJAY_COMMUNICATION_CHANNEL_SUCCESS'

export const GET_MASTER_BLUEJAY_COMMUNICATION_CHANNEL_FAIL = 'GET_MASTER_BLUEJAY_COMMUNICATION_CHANNEL_FAIL'

export const GET_BLUEJAY_COMMUNICATION_CHANNEL_BY_SERVICE_ID = 'GET_BLUEJAY_COMMUNICATION_CHANNEL_BY_SERVICE_ID'

export const GET_BLUEJAY_COMMUNICATION_CHANNEL_BY_SERVICE_ID_SUCCESS = 'GET_BLUEJAY_COMMUNICATION_CHANNEL_BY_SERVICE_ID_SUCCESS'

export const GET_BLUEJAY_COMMUNICATION_CHANNEL_BY_SERVICE_ID_FAIL = 'GET_BLUEJAY_COMMUNICATION_CHANNEL_BY_SERVICE_ID_FAIL'

export const POST_UPDATE_BLUEJAY_COMMUNICATION_CHANNEL_BY_ID = 'POST_UPDATE_BLUEJAY_COMMUNICATION_CHANNEL_BY_ID'

export const POST_UPDATE_BLUEJAY_COMMUNICATION_CHANNEL_BY_ID_SUCCESS = 'POST_UPDATE_BLUEJAY_COMMUNICATION_CHANNEL_BY_ID_SUCCESS'
export const POST_UPDATE_BLUEJAY_COMMUNICATION_CHANNEL_BY_ID_FAIL = 'POST_UPDATE_BLUEJAY_COMMUNICATION_CHANNEL_BY_ID_FAIL'

export const CREATE_UPDATE_TAG = "CREATE_UPDATE_TAG";
export const CREATE_UPDATE_TAG_SUCCESS = "CREATE_UPDATE_TAG_SUCCESS";
export const CREATE_UPDATE_TAG_FAIL = "CREATE_UPDATE_TAG_FAIL";

export const GET_TAG_VALUES = "GET_TAG_VALUES";
export const GET_TAG_VALUES_SUCCESS = "GET_TAG_VALUES_SUCCESS";
export const GET_TAG_VALUES_FAIL = "GET_TAG_VALUES_FAIL";

export const DELETE_TAG_VALUE = "DELETE_TAG_VALUE";
export const DELETE_TAG_VALUE_SUCCESS = "DELETE_TAG_VALUE_SUCCESS";
export const DELETE_TAG_VALUE_FAIL = "DELETE_TAG_VALUE_FAIL";

export const GET_ALL_KEY_NAMES = "GET_ALL_KEY_NAMES";
export const GET_ALL_KEY_NAMES_SUCCESS = "GET_ALL_KEY_NAMES_SUCCESS";
export const GET_ALL_KEY_NAMES_FAIL = "GET_ALL_KEY_NAMES_FAIL";

export const SET_MAINTENANCE_WINDOW_BY_ID = "SET_MAINTENANCE_WINDOW_BY_ID";
export const SET_MAINTENANCE_WINDOW_BY_ID_SUCCESS = "SET_MAINTENANCE_WINDOW_BY_ID_SUCCESS";
export const SET_MAINTENANCE_WINDOW_BY_ID_FAIL = "SET_MAINTENANCE_WINDOW_BY_ID_FAIL";
